import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { signup } from '@/api/auth.api';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Signup mutation (MYN-46 A1). On success the backend has emailed a
 * verification code; we route to the OTP screen carrying the email in
 * navigation state (no token is issued until the email is verified).
 */
export function useSignup() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: signup,
    onSuccess: (result) => {
      navigate(ROUTES.AUTH.VERIFY_EMAIL, {
        // otpEmailSent=false -> the verify screen shows a "we could not send
        // it" notice and unlocks Resend immediately.
        state: { email: result.email, otpEmailSent: result.otpEmailSent !== false },
      });
    },
  });
}
